module.exports = __webpack_public_path__ + "img/detalle-fondo.06d5003a.svg";